import { useId } from 'react'
import { useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { isSidebarNavActive } from '@/lib/sidebar-nav-active'
import type { SidebarNavGroupChild } from '@/types/sidebar'
import { SidebarItem } from '../SidebarItem'
import styles from './SidebarNavGroup.module.css'

export type { SidebarNavGroupChild } from '@/types/sidebar'

type SidebarNavGroupProps = {
  label: string
  icon: string
  iconActive: string
  items: SidebarNavGroupChild[]
  expanded: boolean
  onToggle: () => void
}

export function SidebarNavGroup({
  label,
  icon,
  iconActive,
  items,
  expanded,
  onToggle,
}: SidebarNavGroupProps) {
  const location = useLocation()
  const panelId = useId()
  const isGroupActive = items.some((child) =>
    isSidebarNavActive(location.pathname, child)
  )
  const toggleIcon = isGroupActive ? iconActive : icon

  return (
    <div className={styles.group}>
      <button
        type="button"
        className={
          isGroupActive
            ? `${styles.toggle} ${styles.toggleActive}`
            : styles.toggle
        }
        aria-expanded={expanded}
        aria-controls={panelId}
        aria-label={expanded ? `Recolher ${label}` : `Expandir ${label}`}
        onClick={onToggle}
      >
        <span className={styles.icon} aria-hidden>
          <Icon icon={toggleIcon} width="18" height="18" />
        </span>
        <span className={styles.label}>{label}</span>
        <span
          className={[
            styles.chevron,
            expanded ? styles.chevronExpanded : styles.chevronCollapsed,
          ].join(' ')}
          aria-hidden
        >
          <Icon icon="mdi:chevron-down" width="18" height="18" />
        </span>
      </button>
      {expanded && (
        <ul id={panelId} className={styles.sublist}>
          {items.map((child) => (
            <li key={child.to + child.label}>
              <SidebarItem
                to={child.to}
                label={child.label}
                icon={child.icon}
                exact={child.exact}
                sectionPrefix={child.sectionPrefix}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
